import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryCards from './components/CategoryCards';
import SEOContent from './components/SEOContent';
import ArticleGrid from './components/ArticleGrid';
import ArticleBanner from './components/ArticleBanner';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sugargoo Spreadsheet Hub',
  url: 'https://sugargoosheet.fun/',
  description: 'The ultimate Sugargoo Spreadsheet resource hub with organized product finds, shopping guides, shipping cost breakdowns, coupon codes, and expert reviews.',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://sugargoosheet.fun/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <Navbar />
      <HeroSection />

      {/* Category Dropdown & Quick Link Buttons */}
      <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50" id="categories">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
            Browse Sugargoo Spreadsheet Categories
          </h2>
          <p className="text-sm text-foreground-500 mb-6">
            Select a category below to explore organized product collections
          </p>
          <CategoryDropdown />
          <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-cart-line"></i>
              Sugargoo Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-white font-semibold text-sm rounded-full hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-bag-line"></i>
              Buy It Now
            </a>
          </div>
        </div>
      </section>

      <CategoryCards />
      <ArticleGrid />
      <SEOContent />
      <ArticleBanner />
      <Footer />
    </div>
  );
}